/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import {
  ATTACHMENT_TYPE, COMMUNICATION_BLOCK_TYPE,
  FROM_VIEW_TYPE,
  GlobalStoreKey,
  USER_COMMENT_TYPE,
  USER_REPORT_TYPE,
} from '@v2/constants/common'
import { Button } from '@styles/button.style'
import {
  HitStateSuccessCount,
  UserDetailItem,
  UserPickContentsStyle,
  UserPickPopoverWrap,
  UserPickWrap,
} from '@views/Home/index.style'
import { AdvButton } from '@components/Button'
import TodayBestPickImg from '@assets/images/icon/pick_icon/today-best-pick.png'
import {
  replaceSelectionNameByMarketAndSpecialBetValue,
  formatCreatedAtToElapsedTime,
} from '@utils/utils'
import dayjs from 'dayjs'
import { Schema$UserPick, Schema$UserPickExtend, Schema$UserPickRecentHitRate } from '@interface/user-pick'
import DialogUtils from '@utils/dialog-utils'
import _ from 'lodash'
import uuid from 'uuid'
import useRootStore from '@store/useRootStore'
import { useOnUnmount } from '@utils/reactExt'
import { UserPickProfile } from '@views/Home/UserPick/Components/UserPickProfile'
import { UserPickMarketInfo } from '@views/Home/UserPick/Components/UserPickMarketInfo'
import { PAGE_TYPE } from '@interface/common'
import { BET_HIT_STATE } from 'adv-protocol/src/GameCommon'
import { LikeButton } from '@components/Button/LikeButton'
import { CommentButton } from '@components/Button/CommentButton'
import { SPORT_ID_GRAY_ICON_MAP } from '@shared/SportIdGroup/Gray'
import classNames from 'classnames'
import { isMobile } from 'react-device-detect'
import { SportsIco } from '@styles/match.style'
import { SPORT_ID_ICON_MAP } from '@shared/SportIdGroup'
import PopupUtils from '@utils/popup-utils'
import { BASIC_TEAM_EMBLEM_MAP } from '@shared/EmblemGroup'
import { Popover } from 'antd'
import CommentAddImg from '@assets/images/btn/comment-add-btn.png'
import { Schema$UserComment } from '@interface/comment'
import { runInAction } from 'mobx'
import { makeATagAutoGenerationElements } from '@utils/jsxutils'
import AdvImg from '@components/AdvImg'

const LIKE_ACTIVE_CLASS = 'active'
const openElements = new Set<HTMLElement>()

export interface UserPickItemProps {
  userPick?: Schema$UserPickExtend | Schema$UserPick
  recentHitRate?: Schema$UserPickRecentHitRate
  pageType?: PAGE_TYPE
  className?: string
  disableFavoriteEvent?: boolean
  disableUserInfoClick?: boolean
  disableOverText?: boolean
  showMatchInfoFull?: boolean
  showMatchInfoSimple?: boolean
  onClickUserPickItem?: (userPick: Schema$UserPickExtend) => void
  onUserBlockSuccessHandler?: (userPromiseId: string, blockTypes: COMMUNICATION_BLOCK_TYPE[]) => void
}

export const UserPickItem: React.FC<UserPickItemProps> = observer((props) => {
  const { globalStore, userPickStore, bettingHistoryStore, authStore } = useRootStore()
  const {
    userPick, recentHitRate, pageType, className, disableFavoriteEvent = false,
    showMatchInfoFull = false, showMatchInfoSimple = false, disableUserInfoClick, disableOverText = false,
    onClickUserPickItem, onUserBlockSuccessHandler
  } = props
  const [bubbleVisible, setBubbleVisible] = useState(false)
  const [addSuffixList, setAddSuffixList] = useState('[]')

  const emoticonUrlPrefix = useMemo(() => {
    return globalStore.findGlobalSetting(GlobalStoreKey.CHAT_EMOTICON_URL_PREFIX)?.value
  }, [])
  const attachImgUrlPrefix = useMemo(() => {
    return globalStore.findGlobalSetting(
      GlobalStoreKey.USER_COMMENT_ATTACH_IMAGE_URL_PREFIX,
    )?.value
  }, [])

  useEffect(() => {
    openElements.forEach(el => el.classList.remove('open'))
    openElements.clear()
  }, [userPick])

  useOnUnmount(() => {
    openElements.clear()
  })

  const onClickUserPickLikeBtn = (userPick: Schema$UserPick): void => {
    if (!disableFavoriteEvent) {
      userPickStore.toggleUserPickLiked(userPick.id).catch(console.error)
    }
  }

  const callbackCreated = (comment: Schema$UserComment): void => {
    userPickStore.createCommentCallback(comment)
    PopupUtils.changePopupTitle('pick-comments-list', `나도승부사 댓글 ${userPick.commentCount}`)
  }
  const callbackDeleted = (comment: Schema$UserComment): void => {
    userPickStore.deleteCommentCallback(comment)
    PopupUtils.changePopupTitle('pick-comments-list', `나도승부사 댓글 ${userPick.commentCount}`)
  }

  const userPickEnabled = userPick.enabled

  const onClickUserPickCommentBtn = () => {
    if (!userPickEnabled) {
      return
    }

    bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.USER_PICK_COMMENT)
    bettingHistoryStore.setBettingHistoryInitProps({
      onlyMajorClub: true,
      fromViewType: FROM_VIEW_TYPE.USER_PICK_COMMENT,
    })
    PopupUtils.showAdvComments({
      commentType: USER_COMMENT_TYPE.USER_PICK_COMMENT,
      commentCount: userPick.commentCount,
      fromViewType: FROM_VIEW_TYPE.USER_PICK_COMMENT,
      targetId: userPick.id.toString(),
      callbackCreated,
      callbackDeleted,
    })
  }

  const onClickUserDetailInfoPopup = () => {
    if (disableUserInfoClick) {
      return
    }
    PopupUtils.showUserDetailInfo(userPick.pickOwner.userPromiseId)

    console.log(userPick.pickOwner.userPromiseId)
  }

  const [isShowMore, setIsShowMore] = useState(false)
  const [isSocialMedia, setIsSocialMedia] = useState(false)
  const textLimit = 170

  const row = _.split(userPick.content, '\n').length - 1

  // 170자가 넘어가거나 5줄이 넘어가는 경우
  const isOverText = !disableOverText && ((_.size(userPick.content) > textLimit) || row > 5)

  let shortTextLimitClass = ''

  if (isOverText && !isShowMore) {
    // 총 글자수는 적은데 5줄 이상인 경우
    if ((textLimit > _.size(userPick.content)) && row > 5) {
      shortTextLimitClass = 'short'
    }
  }

  const userPickContent = useMemo(() => {
    let content = userPick.content

    if (isOverText && !isShowMore) {
      content = userPick.content?.slice(0, textLimit)
    }

    return (
      makeATagAutoGenerationElements(globalStore, content, isSocialMedia, () => {
        if (!isSocialMedia) {
          setIsSocialMedia(true)
        }
      })
    )
  }, [isSocialMedia, isShowMore, userPick])

  const onClickToggleBtn = (e) => {
    const elements = e.currentTarget

    if (isOverText && !isShowMore) {
      setIsShowMore(!isShowMore)

      if (_.includes(elements.classList, 'open')) {
        elements.classList.remove('open')
      } else {
        elements.classList.add('open')
      }
    }

    openElements.add(elements)
  }

  const onClickViewImg = (imageSrc: string) => {
    DialogUtils.showImagePreview({ imageSrc })
  }

  let ellipsisTxt
  if ((textLimit > _.size(userPick.content)) && row > 5) {
    // 총 글자수는 적은데 5줄 이상인 경우
    ellipsisTxt = (
      <Fragment>
        <p>{userPickContent}</p>{isOverText && !isShowMore && '...'}
      </Fragment>
    )
  } else {
    ellipsisTxt = (
      <p>
        {userPickContent}{isOverText && !isShowMore && '...'}
      </p>
    )
  }
  const successCount = recentHitRate?.hitStateSuccessCount ?? 0
  const count = recentHitRate?.count ?? 0
  const recentPercent = successCount / count

  const makeHitRate = (recentHitRate: Schema$UserPickRecentHitRate): string => {
    if (_.isNil(recentHitRate)) return '-'

    if (count > 0) {
      return `${Math.floor(recentPercent * 100)}%`
    }
    return '-'
  }

  const topRankRate = 0.8
  const middleRankRate = 0.5

  const recentHitRateClass = classNames(
    'recent-hit-rate',
    { 'effect': recentPercent >= topRankRate },
    { 'color': recentPercent >= middleRankRate },
  )

  const profileContents = (
    <Fragment>
      <UserPickProfile userInfo={userPick.pickOwner} showSMark={userPick.pickOwner.hasMark}/>
      {!_.isNil(recentHitRate) && (
        <HitStateSuccessCount>
          <div style={{ position: 'relative' }}>
            <div className={recentHitRateClass}>
              {makeHitRate(recentHitRate)}
            </div>
            {recentPercent >= topRankRate &&
              <Fragment>
                <span className="light big">{makeHitRate(recentHitRate)}</span>
                <span className="light">{makeHitRate(recentHitRate)}</span>
              </Fragment>
            }
          </div>

          <div className="hit-state-count">
            ({recentHitRate?.hitStateSuccessCount ?? 0}/{recentHitRate?.count ?? 0})
          </div>
        </HitStateSuccessCount>
      )}
    </Fragment>
  )

  const addEmoticonSuffixHandler = (e, itemId: string): void => {
    e.stopPropagation()
    const suffixObj = JSON.parse(addSuffixList)
    let suffix = _.find(suffixObj, { itemId })
    if (suffix) {
      suffix.suffix = uuid.v4()
      _.remove(suffixObj, { itemId })
    } else {
      suffix = { itemId, suffix: uuid.v4() }
    }
    suffixObj.push(suffix)
    setAddSuffixList(JSON.stringify(suffixObj))
  }

  const makeEmoticonAttachmentUrl = () => {
    const attachment = userPick.attachment
    const itemId = userPick.id
    const suffixObj = JSON.parse(addSuffixList)
    const suffix = _.find(suffixObj, { itemId })
    return `${emoticonUrlPrefix}${attachment}?i=${itemId}&t=${suffix ? suffix.suffix : uuid.v4()}`
  }

  const contents = (
    <Fragment>
      <div className={`contents ${shortTextLimitClass}`}>

        {ellipsisTxt}

        {userPick.type === ATTACHMENT_TYPE.IMAGE &&
          <div className={(isOverText && !isShowMore) ? 'adv-hidden' : 'contents--upload'}>
            <Button
              className="attachment-img-btn"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                onClickViewImg(`${attachImgUrlPrefix}${userPick.attachment}`)
                return false
              }}>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
              <AdvImg src={`${attachImgUrlPrefix}${userPick.attachment}`} srcMode={'default'} alt="업로드 이미지" className="upload-img-preview lhn7" loading="lazy"/>
            </Button>
          </div>
        }

        {userPick.type === ATTACHMENT_TYPE.EMOTICON &&
          <div className={(isOverText && !isShowMore) ? 'adv-hidden' : 'contents--upload'}>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
            <img
              src={makeEmoticonAttachmentUrl()}
              alt="이모티콘"
              className="upload-img-preview emoticon"
              loading="lazy"
              onClick={(e) => addEmoticonSuffixHandler(e, _.toString(userPick.id))}
            />
          </div>
        }
      </div>

      {(isOverText && !isShowMore) && <span className="more-txt">더 보기</span>}
    </Fragment>
  )

  let ongoingTxt = ''
  const hitStateClassName = useMemo(() => {
    const classNames = ['circle']
    switch (userPick.hitState) {
      case BET_HIT_STATE.SUCCESS:
        classNames.push('success')
        break
      case BET_HIT_STATE.CANCEL:
        classNames.push('cancel')
        break
      case BET_HIT_STATE.FAIL:
        classNames.push('fail')
        break
      case BET_HIT_STATE.ONGOING:
        classNames.push('ongoing')
        ongoingTxt = '마감전'
        break
    }
    return classNames.join(' ')
  }, [userPick])

  const convertSelectionName = useCallback((userPick: Schema$UserPick): string => {
    return replaceSelectionNameByMarketAndSpecialBetValue(
      userPick.selectionName,
      userPick.marketName,
      userPick.specialBetValue,
    )
  }, [userPick])

  const onVisibleChange = (visible): void => {
    setBubbleVisible(visible)
  }

  const onClickReportComment = (): void => {
    if (!userPick.reported) {
      setBubbleVisible(false)
      DialogUtils.showUserReport({
        reportType: USER_REPORT_TYPE.USER_PICK,
        targetId: _.toString(userPick.id),
        targetUserPromiseId: userPick.pickOwner.userPromiseId,
        callbackReport: (result) => {
          if (result) {
            runInAction(() => {
              userPick.reported = true
            })
          }
        }
      })
    }
  }

  const onClickBlockUser = () => {
    const { userPromiseId, userNick, userProfileImg } = userPick.pickOwner
    if (!userBlock) {
      DialogUtils.showUserBlock(userPromiseId, userNick, userProfileImg, onUserBlockSuccessHandler)
    } else {
      DialogUtils.showUserUnBlock(userPromiseId, onUserBlockSuccessHandler)
    }
  }

  const isUserBlockEnabled = globalStore.getUserBlockEnabled()
  const isPossibleUserBlock = globalStore.isPossibleUserBlockByUserPromiseId(userPick.pickOwner.userPromiseId)
  const userBlock = userPick.pickOwner.isBlocked
  const popoverContent = (
    <UserPickPopoverWrap>
      <Fragment>
        <Button TP className="popover-btn" onClick={onClickReportComment}>
          {userPick.reported ? '신고완료' : '신고하기'}
        </Button>
        {isUserBlockEnabled && isPossibleUserBlock && (
          <Button TP className={userBlock ? 'popover-btn delete' : 'popover-btn'} onClick={onClickBlockUser}>
            {userBlock ? '차단해제' : '차단하기'}
          </Button>
        )}
      </Fragment>
    </UserPickPopoverWrap>
  )

  let isMime = false
  if (userPick.pickOwner.userPromiseId === authStore.userInfo.id) {
    isMime = true
  }

  const userPickBlock = userPick.isBlocked
  let userPickContents
  if (userPickBlock) {
    userPickContents = <div className="block-message">차단된 유저의 분석글입니다.</div>
  } else if (!userPickEnabled){
    userPickContents = <div className="block-message">삭제된 분석글입니다.</div>
  } else {
    userPickContents = (
      <Fragment>
        <UserPickMarketInfo data={userPick}/>
        <AdvButton
          contents={contents}
          onClick={onClickToggleBtn}
          css={UserPickContentsStyle}
          className={isOverText && !isShowMore && 'show-more'}
        />
      </Fragment>
    )
  }

  let userPickItemContents
  if (pageType === PAGE_TYPE.USER_PICK_PROFILE) {
    userPickItemContents = (
      <div className="pick-contents test222">
        <div className="select-box">
          <div className="outcome">
            <span className="selection">{convertSelectionName(userPick)}</span>
            <span className="outcome-rate">{userPick.outcomeRate}</span>
          </div>
          {userPick.marketName}&nbsp;<span className="rate">{userPick.specialBetValue}</span>
          <span className={hitStateClassName}>{ongoingTxt}</span>
        </div>
      </div>
    )
  } else {
    userPickItemContents = (
      <Fragment>
        <div className="profile-wrap">
          <AdvButton
            padding={'0 12px 0 0'}
            contents={profileContents}
            onClick={onClickUserDetailInfoPopup}
          />
          {!userPickBlock && userPick.isBestPick && (
            <span className="today-best-pick">
              <img src={TodayBestPickImg} alt="오늘의 승부사" loading="lazy"/>
            </span>
          )}
        </div>

        <div className={isMobile ? 'pick-contents' : 'pick-contents pc'}>
          <div className={userBlock || !userPickEnabled ? 'nickname blocked' : 'nickname'}>
            {userPick.pickOwner.userNick}
            {!isMime && (
              <div id={`UserPickContentsButton_${pageType}_${userPick.id}`}
                   style={{ position: 'relative', float: 'right' }}>
                <Popover
                  key={`UserPickContentsButton_popover_${pageType}_${userPick.id}`}
                  visible={bubbleVisible}
                  onVisibleChange={onVisibleChange}
                  placement="bottomLeft"
                  content={popoverContent}
                  trigger={isMobile ? 'click' : 'hover'}
                  mouseLeaveDelay={0.05}
                  overlayClassName={'user-comment-menu'}
                  // getPopupContainer={() => document.getElementById('UserPickContentsButton')}
                  getPopupContainer={(triggerNode: any) => triggerNode.parentNode} /* body 하위에 div를 생성하지 않고 additional-dividend-mark과 동일 선상에 생성되도록 설정 - body 하위에 생성되면 아이폰에서 모달 뒤에 뜸 */
                >
                  <Button TP className="odds-block-list--btn sub-btn extra-btn"
                          style={{ width: 20, marginLeft: 5 }}>
                    <img src={CommentAddImg} alt="댓글 추가버튼" style={{ width: 3 }} loading="lazy"/>
                  </Button>
                </Popover>
              </div>
            )}
            <span className="date">{formatCreatedAtToElapsedTime({ createdAt: userPick.createdAt })}</span>
          </div>

          {userPickContents}

          <div>
            <LikeButton
              id="userPickLikeBtn"
              className={`${userPick.isLiked ? LIKE_ACTIVE_CLASS : ''}`}
              count={userPick.likeCount}
              onClick={() => onClickUserPickLikeBtn(userPick)}
            />
            <CommentButton
              id="userPickCommentBtn"
              onClick={() => onClickUserPickCommentBtn()}
              count={userPick.commentCount}
            />
          </div>

        </div>
        <span className="line"/>
      </Fragment>
    )
  }

  if (showMatchInfoFull) {
    const matchInfoClass = classNames(
      'match-info row popup',
      { 'pc-info': !isMobile },
    )
    const {
      sportId, dateOfMatch, homeTeamName, awayTeamName,
      homeTeamEmblem, awayTeamEmblem,
    } = userPick as Schema$UserPickExtend
    return (
      <UserPickWrap
        className="user-pick-profile"
        onClick={() => {
          if (onClickUserPickItem) {
            onClickUserPickItem(userPick as Schema$UserPickExtend)
          }
        }}>
        <div className={matchInfoClass}>
          <SportsIco>{SPORT_ID_ICON_MAP[sportId]}</SportsIco>
          <span className="date">{dayjs(dateOfMatch).format('MM/DD(ddd) HH:mm')}</span>
          <div className="team-info">
            <span className="team">
              <span className="emblem">
                <img src={homeTeamEmblem || BASIC_TEAM_EMBLEM_MAP[sportId]} alt="홈팀 엠블럼" loading="lazy"/>
              </span>
              {homeTeamName}
            </span>
            <span className="vs">vs</span>
            <span className="team">
              <span className="emblem">
                <img src={awayTeamEmblem || BASIC_TEAM_EMBLEM_MAP[sportId]} alt="원정팀 엠블럼" loading="lazy"/>
              </span>
              {awayTeamName}
            </span>
          </div>
        </div>
        <UserDetailItem className={className}>
          {userPickItemContents}
        </UserDetailItem>
      </UserPickWrap>
    )
  }

  if (showMatchInfoSimple) {
    const matchInfoClass = classNames(
      'match-info row simple-info',
      { 'pc-info': !isMobile },
    )
    const { sportId, dateOfMatch, homeTeamName, awayTeamName } = userPick as Schema$UserPickExtend
    let dateTxt
    if (dayjs(dateOfMatch).format('MM/DD') === dayjs().format('MM/DD')) {
      dateTxt = (
        <span className="date">
          <span className="today">오늘</span>{dayjs(dateOfMatch).format('(ddd) HH:mm')}
        </span>
      )
    } else {
      dateTxt = <span className="date">{dayjs(dateOfMatch).format('MM/DD(ddd) HH:mm')}</span>
    }
    return (
      <UserPickWrap>
        <div className={matchInfoClass}>
          {SPORT_ID_GRAY_ICON_MAP[sportId]}
          {dateTxt}
          <div className="team-info">
            <span className="team">
              {homeTeamName}
            </span>
            <span className="vs">vs</span>
            <span className="team">
              {awayTeamName}
            </span>
          </div>
        </div>
        <UserDetailItem className={className}>
          {userPickItemContents}
        </UserDetailItem>
      </UserPickWrap>
    )
  }

  return (
    <UserDetailItem className={className}>
      {userPickItemContents}
    </UserDetailItem>
  )
})
